import e from "./index238.js";
import { resolveComponent as n, createElementBlock as s, openBlock as t, normalizeClass as r, createVNode as c } from "vue";
/* empty css         */
import m from "./index231.js";
const p = ["data-component"];
function _(o, i, k, d, l, f) {
  const a = n("ms-bookmark");
  return t(), s("span", {
    "data-component": o.$options.name,
    class: r(["cs-bookmark-icon", {
      "-hasDot": o.hasDot
    }])
  }, [
    c(a, { class: "cs-bookmark-icon__icon" })
  ], 10, p);
}
const B = /* @__PURE__ */ m(e, [["render", _], ["__scopeId", "data-v-3aada5eb"]]);
export {
  B as default
};
